import { Controller } from "@hotwired/stimulus";

// Etapa de tradução da Área do Parceiro. Pede ao servidor a tradução do texto que o dono já
// salvou e coloca o resultado nos campos do outro idioma, que continuam editáveis: nada é
// gravado até o dono confirmar o formulário.
export default class extends Controller {
  static targets = ["short", "description", "status", "button"];
  static values = {
    url: String,
    auto: Boolean,
    generating: String,
    done: String,
    failed: String,
  };

  connect() {
    if (this.autoValue) this.generate();
  }

  async generate() {
    this.#busy(true, this.generatingValue);

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        },
      });
      const data = await response.json();

      if (!response.ok) {
        this.#busy(false, data.error || this.failedValue);
        return;
      }

      if (data.short_description) {
        this.shortTarget.value = data.short_description;
        this.shortTarget.dispatchEvent(new Event("input", { bubbles: true }));
      }
      if (data.description && this.hasDescriptionTarget) {
        // O editor (TipTap, carregado sob demanda) lê o input escondido quando monta e ouve
        // tiptap:set-content depois de montado. Os dois cobrem a resposta chegar antes ou
        // depois do editor.
        this.descriptionTarget.value = data.description;
        this.descriptionTarget.dispatchEvent(
          new CustomEvent("tiptap:set-content", { detail: { html: data.description } })
        );
      }

      this.#busy(false, this.doneValue);
    } catch (error) {
      this.#busy(false, this.failedValue);
    }
  }

  #busy(busy, message) {
    if (this.hasButtonTarget) this.buttonTarget.disabled = busy;
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message || "";
      this.statusTarget.classList.toggle("is-busy", busy);
    }
  }
}
